<template>
   <tool-select-wrapper
      label="SST"
      icon-url="/static/icons/tools/polygon.svg"
      :selected="sstIsSelected"
      @click="selectSSTTool"
      >
      <div class='sst-tool-wrapper'>
         <p>Please select one municipality from dropdown menu</p>
         <atom-button
            label="Edit Parameters"
            color="light"
            @click="showParamsForm=true"
            full-width
         />
         <atom-button
            label="Generate spatial sampling"
            color="light"
            @click="doSpatialSampling"
            full-width
         />
      </div>
      <sst-params-form
         :visible='showParamsForm'
         :parent-params="sstParams"
         @submit='handleSubmit'
         @close='showParamsForm=false'
      />
   </tool-select-wrapper>
</template>

<script>
import AtomButton from '@/components/atoms/Login/Button';
import SstParamsForm from '@/components/organisms/Home/MepToolMap/SSTParamsForm';
import ToolSelectWrapper from '../ToolSelectWrapper';
import { SST } from '@/store/modules/tools';
import { mapGetters,mapActions } from 'vuex';
import { replaceClusterFeatures, handleToolModeSelection, getSelectedSDDMM } from '@/js/tools/sst';
import { showError } from '@/js/ui-helpers';

export default {
   components: {
      AtomButton,
      ToolSelectWrapper,
      SstParamsForm, 
   },
   computed: mapGetters('tools', ["sstIsSelected"]),
   data()
   {
      return {
         sstParams: {
            hh_per_municipality: 400,
            hh_per_cluster_urban: 10,
            hh_per_cluster_rural: 10,
            desired_cluster_size: 5,
         },
         showParamsForm: false,
      };
   },
   watch: {
      sstIsSelected(isSelected)
      {
         handleToolModeSelection(isSelected);
      }
   },
   beforeDestroy()
   {
      handleToolModeSelection(false);
      this.clearResults({sst: true});
   },
   methods: {
      ...mapActions('tools', ['setCurrentTool', 'performSstAnalysis', "clearResults"]),
      handleSubmit(params)
      {
         this.sstParams = params;
         this.showParamsForm = false;
      },
      selectSSTTool()
      {
         this.setCurrentTool(SST);
      },
      async doSpatialSampling()
      {
         const sddmm = getSelectedSDDMM();
         if (!sddmm)
         {
            showError('SST Tool', "Please select a municipality first");
            return;
         }
         const {success, data} = await this.performSstAnalysis({sddmm: sddmm.toString(), ...this.sstParams});
         if (success)
         {
            replaceClusterFeatures(data.cluster_geojson);
         }
      }
   },
}
</script>

<style lang="scss" scoped>
.sst-tool-wrapper {
   padding: 10px;
   padding-bottom: 6px;
   p {
      font-size: 14px;
      font-family: $primary-font;
      color: $font-color;
   }
}
</style>
